var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0937 4.79883C10.0937 4.10847 10.6534 3.54883 11.3437 3.54883H12.0699C13.1871 3.54883 14.135 4.36845 14.2964 5.47385L14.7341 8.47314C14.7521 8.59596 14.8574 8.68703 14.9815 8.68703H18.3946C19.8272 8.68703 20.8949 10.008 20.5947 11.4087L18.9034 19.2981C18.681 20.3354 17.7642 21.0764 16.7034 21.0764H8.31348C8.33989 20.9555 8.35381 20.83 8.35381 20.7012V9.87695C8.35381 9.78814 8.34719 9.70086 8.33442 9.6156L8.8963 9.31819C9.63295 8.92827 10.0937 8.16307 10.0937 7.32959V4.79883Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.60352 9.12695H4.60352C3.91316 9.12695 3.35352 9.6866 3.35352 10.377V20.2012C3.35352 20.8915 3.91316 21.4512 4.60352 21.4512H6.62284C7.02812 21.4409 7.35352 21.1092 7.35352 20.7014V9.8772C7.35352 9.46298 7.01773 9.12695 6.60352 9.12695Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLike);
export default __webpack_public_path__ + "static/media/DuoLike.8894a0322f72de62c4e745bdbd6dcdb1.svg";
export { ForwardRef as ReactComponent };